import { Component, ElementRef, EventEmitter, inject, input, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CategoryService } from '../../Services/category.service';
import { getAllCategories } from '../../models/Categories Requests DTO/get-categroies.model';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-categories-scroller',
  templateUrl: './categories-scroller.component.html',
  styleUrls: ['./categories-scroller.component.scss'],
})
export class CategoriesScrollerComponent implements OnInit {
  @Output() categorySelected = new EventEmitter<number>();
  @ViewChild('scrollerContainer', { static: false })
  scrollerContainer!: ElementRef<HTMLDivElement>;

  categories!: getAllCategories[];
  selectedCategoryId: number | null = null;
  categoryName!: string;

  languageService = inject(LanguageService);

  inputid = input<number>();

  constructor(private categoryService: CategoryService) {}

  ngOnInit(): void {
    this.categoryService.getAllCategories().subscribe({
      next: (result) => {
        this.categories = result
        .filter(category => category.visible === true)  // or just category.visible
        .sort((a, b) => a.ordernumber - b.ordernumber);
        // Automatically select and center the category if inputid is provided
        if (this.inputid !== undefined) {
          const categoryExists = this.categories.find((cat) => cat.id === this.inputid());
          if (categoryExists) {
            this.onCategorySelect(this.inputid() ?? 0); // Safe to pass inputid here
          } else {
            console.warn(`Category with ID ${this.inputid} not found.`);
          }
        }
        
      },
      error: (err) => {
        console.error('Error fetching categories:', err);
      },
    });
  }
  

  ngAfterViewInit(): void {
    setTimeout(() => {
      const container = this.scrollerContainer.nativeElement;
      const scroller = container.querySelector('.scroller') as HTMLElement;
      scroller.style.width = `${this.categories.length * 160}px`; // 150px per item + 10px gap
    //  console.log('Updated scroller width:', scroller.style.width);
    }, 0);
  }
  
  
  scrollLeft(): void {
    const container = this.scrollerContainer.nativeElement;
  
    container.scrollTo({
      left: container.scrollLeft - 150,
      behavior: 'smooth', // Use 'auto' for instant scrolling
    });
  
  }
  
  scrollRight(): void {
    const container = this.scrollerContainer.nativeElement;

    container.scrollTo({
      left: container.scrollLeft + 150,
      behavior: 'smooth',
    });
  
  }
  
  
  
  centerCategory(categoryId: number): void {
    const container = this.scrollerContainer.nativeElement;
    const selectedElement = container.querySelector(
      `.category:nth-child(${this.categories.findIndex((cat) => cat.id === categoryId) + 1})`
    ) as HTMLElement;
  
    if (selectedElement) {
      const containerWidth = container.clientWidth;
      const elementOffsetLeft = selectedElement.offsetLeft;
      const elementWidth = selectedElement.clientWidth;
  
      const scrollPosition =
        elementOffsetLeft - (containerWidth / 2) + (elementWidth / 2);
  
      container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
    }
  }
  
  onCategorySelect(id: number): void {
    this.selectedCategoryId = id; // Update the selected category ID
    this.categorySelected.emit(id); // Emit the selected category
    this.centerCategory(id); // Center the selected category
  }
  
  
}
